/**
 * Case-insensitive substring match against any of the supplied parts.
 * Empty query matches everything so callers can use it as a view filter
 * without a separate branch.
 */
export function matchesQuery(
    query: string,
    parts: readonly (string | null | undefined)[],
): boolean {
    const q = query.trim().toLowerCase();
    if (q === "") return true;
    for (const part of parts) {
        if (part === null || part === undefined) continue;
        if (part.toLowerCase().includes(q)) return true;
    }
    return false;
}
